import React, { useState } from 'react';
import { User } from '@apply/store/src/user/types';
import { isMobileScreen, ConfirmV2, Confirm } from '@apply/ui';
import { useNavigate } from 'react-router-dom';
import { FlyoutMenuButton, FlyoutDirection, IconButtonSize, IconButtonTheme } from '@apply/components';
import { useAuthentication } from '../../LoginPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faSignOut, faBars, faMedal } from '@fortawesome/free-solid-svg-icons';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const mobileScreen = isMobileScreen();
export const appInsightsApply = import.meta.env.VITE_APPINSIGHTS_CLIENT_APPLY;
const ai = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsApply,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
    },
});
ai.loadAppInsights();

export const ProfileButton: React.FC<{ user: User; printMode?: boolean }> = ({ user, printMode = false }) => {
    const navigate = useNavigate();
    const { logout } = useAuthentication();
    const [isConfirmOpen, set_isConfirmOpen] = useState(false);

    const onConfirmLogout = () => {
        const stackTrace = Error().stack;
        ai.appInsights.trackTrace({ message: 'onConfirmLogout' }, { stackTrace });
        logout();
        set_isConfirmOpen(false);
        navigate('/login');
    };

    const onCancelLogout = () => {
        set_isConfirmOpen(false);
    };

    const handleLogout = () => {
        set_isConfirmOpen(true);
    };

    const renderProfileButton = (printMode?: boolean) => {
        if (!printMode) {
            if (!mobileScreen) {
                return (
                    <FlyoutMenuButton
                        id='profileButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.White}
                        size={IconButtonSize.Medium}
                        icon={faUserCircle}
                    >
                        <ul style={{ textAlign: 'center' }}>
                            <li>
                                <a onClick={handleLogout}>
                                    <FontAwesomeIcon
                                        icon={faSignOut}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </FlyoutMenuButton>
                );
            } else {
                return (
                    <FlyoutMenuButton
                        id='menuButton'
                        direction={FlyoutDirection.Left}
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        icon={faBars}
                    >
                        <ul style={{ textAlign: 'center' }}>
                            <li>
                                <a href='/experience'>
                                    <FontAwesomeIcon
                                        icon={faMedal}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Experience
                                </a>
                            </li>
                            <hr className='flyout-itemSeperator' />
                            <li>
                                <a onClick={handleLogout}>
                                    <FontAwesomeIcon
                                        icon={faSignOut}
                                        style={{ paddingRight: '10px' }}
                                    />
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </FlyoutMenuButton>
                );
            }
        }
    };

    return (
        <>
            {renderProfileButton(printMode)}
            <ConfirmV2
                id='confirmLogoutModal'
                open={isConfirmOpen}
                title='Confirm Logout'
                onConfirm={onConfirmLogout}
                onCancel={onCancelLogout}
                okLabel='Yes'
                cancelLabel='No'
                width='340px'
                height='200px'
            >
                Warning: Unsaved work may be lost
            </ConfirmV2>
        </>
    );
};
